import React from 'react';
import { Bell, ArrowRight, Check, Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const AppointmentNotificationsPage = () => {
  const { login } = useAuth();
  const features = ['Lembretes automáticos', 'Confirmação por WhatsApp', 'Reduza no-shows', 'Reagendamento fácil'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Bell className="h-4 w-4" />Notificações
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">Notificações</span> de agendamentos
              </h1>
              <p className="text-xl text-gray-600 mb-8">Envie lembretes automáticos e reduza faltas com notificações por WhatsApp.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-blue-50 rounded-3xl p-6">
              <div className="bg-white rounded-2xl p-4 shadow-sm">
                <div className="flex items-center gap-3 mb-3">
                  <Calendar className="h-6 w-6 text-[#3b82f6]" />
                  <span className="font-semibold">Lembrete de consulta</span>
                </div>
                <p className="text-sm text-gray-600 mb-4">Sua consulta é amanhã às 14:00. Confirme sua presença:</p>
                <div className="grid grid-cols-2 gap-2">
                  <Button className="bg-green-500 hover:bg-green-600">✓ Confirmar</Button>
                  <Button variant="outline">Reagendar</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Reduza faltas com lembretes</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default AppointmentNotificationsPage;
